import {FaLocationDot} from "react-icons/fa6";
import {IoCallSharp} from "react-icons/io5";
import wave from "../assets/images/wave2.png";
import {Link, useLocation, useNavigate} from "react-router-dom";
import React, {useEffect, useState} from "react";
import SocialIcons from "./SocialIcons";

const Footer = () => {

    const location = useLocation();
    const navigate = useNavigate();
    const [hashToScroll, setHashToScroll] = useState(null);

    useEffect(() => {
        if (hashToScroll) {
            const targetElement = document.getElementById(hashToScroll);
            if (targetElement) {
                targetElement.scrollIntoView({ behavior: "smooth" });
                setHashToScroll(null); // Reset after scrolling
            }
        }
    }, [location, hashToScroll]);

    const handleNavigateToHash = (path, hash) => {
        // check if the path is same or not
        if (location.pathname !== path) {
            setHashToScroll(hash);
            navigate(path);
        } else {
            // If already on the same page, scroll directly
            const targetElement = document.getElementById(hash);
            if (targetElement) {
                targetElement.scrollIntoView({ behavior: "smooth" });
            }
        }
    };

    return (

        <div className={'-mt-16'}>
            <img src={wave} className={'-mb-3 w-screen'} alt=""/>
            <div className={'md:pt-0 pt-4 md:px-20 px-12 pb-8 text-white bg-oxford-blue relative'}>
                <div className={'flex flex-col md:flex-row'}>

                    <div className={'md:w-1/2 flex mb-6'}>
                        <h1 className={'md:w-2/3 text-5xl lg:text-[40px] md:text-[32px] text-[28px] font-black font-sinhalaPrimary'}>වසර
                            කිහිපයක් අතුලත අඛණ්ඩව ප්‍රතිඵල 100% පෙන්වූ
                            විද්‍යා පන්තිය</h1>
                    </div>

                    <div className={'flex flex-col sm:flex-row md:w-1/2 justify-between'}>
                        <div className={'mb-6 md:mb-0'}>
                            <h1 className={'md:text-2xl text-lg font-semibold'}>Navigation</h1>
                            <ul className={'mt-2 flex flex-col gap-y-1 md:text-md text-sm'}>
                                <li className="cursor-pointer" onClick={() => handleNavigateToHash("/", "Home")}>Home</li>
                                <li className="cursor-pointer"><Link to="/results">Results</Link></li>
                                <li className="cursor-pointer" onClick={() => handleNavigateToHash("/", "About")}>About</li>
                                <li className="cursor-pointer" onClick={() => handleNavigateToHash("/", "Contact")}>Contact</li>
                            </ul>
                        </div>
                        <div className={'md:pl-4 mb-4 md:mb-0'}>
                            <h1 className={'md:text-2xl text-lg font-semibold'}>Contact Us</h1>
                            <ul className={'mt-2 flex flex-col gap-y-1 md:text-md text-sm'}>
                                <li className={'flex items-center'}>
                                    <FaLocationDot/>
                                    <span className={'ml-2'}>47/3, Ukuwela, Matale, Srilanka</span>
                                </li>
                                <li className={'flex items-center'}>
                                    <IoCallSharp/>
                                    <span className={'ml-2'}>+94 750360097</span>
                                </li>
                                <SocialIcons />
                            </ul>
                        </div>
                    </div>
                </div>
                <div className={'w-full flex justify-center mt-8'}>
                    <p className={'border-b-2 w-max md:text-sm text-xs'}>
                        <a href="https://sprintcodelabs.com/" target="_blank" rel="noreferrer">
                        Developed by SprintCode Labs.
                        </a> © All rights reserved.
                    </p>
                </div>
            </div>
        </div>

    )
}

export default Footer
